import React from 'react';
import SMStorage from 'lib/SMStorage';
import SMUserResource from 'resources/SMUserResource';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';
import Spinner from 'components/shared/SMMaterialSpinner';
import sprintf from 'sprintf';

class SMNotificationListView extends React.Component {

  notificationDidClick(e) {

    e.stopPropagation();
    e.preventDefault();

    let target = e.currentTarget,
        tag = $(target).data("tag"),
        queries = {},
        notification = this.props.notifications[tag];
    SMUserResource.readNotification(this.props.currentUser.username, notification.id, queries, (response, error, xhr)=>{
      let notificationItems = this.props.notifications;
      notificationItems[tag] = response;
      this.setState({
        notificationItems: notificationItems,
        badgeNumber: response.unckecked_notifications_number
      });
      window.location = target.href;
    });

    let cacheKey = sprintf("notifications-%s", this.props.currentUser.username);
    SMStorage.removeSessionItem(cacheKey);
  }

  render() {
    if (this.props.display == SMConst.Display.Loading) {
      return(
        <div>
          <h2 className="site-header__nav-baloon-title">お知らせ</h2>
          <div className="js-empty"><Spinner /></div>
        </div>
      );
    }
    else if (!this.props.notifications || !this.props.notifications.length) {
      return <p className="site-header__nav-baloon-nodata">通知はありません</p>;
    }

    let rows = [];
    for (let rowIndex = 0; rowIndex < this.props.notifications.length; rowIndex++) {
      let notification = this.props.notifications[rowIndex],
          className = "site-header__nav-baloon-menu clearfix";
      if (!notification.read_at) className += " is-new";

      let url = "#";
      if (notification.about_type == "Reservation") {
        let reservation = notification.about;
        if (reservation.user.id == this.props.currentUser.id) {
          if (notification.notification_type == SMConst.NotificationType.MessageUpdated) {
            url = Routes.dashboard_message_path(reservation.uid);
          } else {
            url = Routes.dashboard_reservation_path(reservation.uid);
          }
        } else {
          if (notification.notification_type == SMConst.NotificationType.MessageUpdated) {
            url = Routes.owner_dashboard_message_path(reservation.owner.username, reservation.uid);
          } else {
            url = Routes.owner_dashboard_reservation_path(reservation.owner.username, reservation.uid);
          }
        }
      }
      else if (notification.about_type == "Owner") {
        let owner = notification.about;
        url = Routes.owner_dashboard_path(owner.username);
      }
      else if (notification.about_type == "Point") {
        url = Routes.dashboard_points_available_point_histories_path();
      }
      else if (notification.about_type == 'PointReferral') {
        url = Routes.referrals_path();
      }
      else if (notification.notification_type == SMConst.NotificationType.ServiceNotification) {
        url = notification.link;
      }

      let name;
      if (notification.from_type == 'AdminUser') {
        name = I18n.t("dashboard.label_000001");
      } else if (notification.from_type == 'Owner') {
        name = SMFormatHelper.ownerName(notification.from);
      } else {
        name = notification.from.contact_name;
      }
      rows.push(
        <li className={className} key={rowIndex}>
          <a onClick={this.notificationDidClick.bind(this)} href={url} data-tag={rowIndex} className="link-black link-borderless">
            <p className="site-header__nav-baloon-message-content">{notification.content}</p>
            <div className="site-header__nav-baloon-message-name">
              <p><img src={SMFormatHelper.userImageUrl(notification.from, notification.from.profile_image)} alt={name} /></p>
              <p>{name}<span>{SMFormatHelper.relativeTime(notification.created_at)}</span></p>
            </div>
          </a>
        </li>
      );
    }

    if (this.canRequest) {
      rows.push(
        <li key={rows.length} className="js-loading-row">読み込んでいます...</li>
      );
    }

    return(
      <div>
        <h2 className="site-header__nav-baloon-title">お知らせ</h2>
        <ul>{rows}</ul>
      </div>
    );
  }

}
export default SMNotificationListView;



// WEBPACK FOOTER //
// ./app/javascript/components/notifications/SMNotificationListView.jsx